export const acceptedFormats = {
  'image/*': ['.jpg', '.jpeg', '.png'],
};
export const importAcceptedFormat = {
  'text/csv': ['.csv'],
  'text/plain': ['.txt'],
  'application/octet-stream': ['.parquet'],
};
